import { useEffect, useState, forwardRef } from "react";
import { useSelector } from "react-redux";
import { fetchApi } from "../../services/apiService";
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const SerialNoFromInventoryAutocomplete = forwardRef((props, ref) => {
    const { itemId = null, selectedValues = [], editMode = false, isFormikFormField = false, showFormError = false, forStoreId = null, onlyLoginBranchStore = false, onlyAvailableInStock = false, defectiveStatus = "N", disabled = false, ...rest } = props;
    let serialNoOptions = [];

    let initialProps = {
        ...rest,
        labelKey: "serialNo",
        primaryKey: "serialNo",
        options: serialNoOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        dataLoaded: false,
        editMode,
        disabled
    }
    const userToken = useSelector((state) => state.login.userToken);

    const [defaultProps, setDefaultProps] = useState(initialProps);

    useEffect(() => {
        const getItemSerialNos = async () => {

            if (!itemId) return;

            let getSerialNoParams = { itemId };

            if (forStoreId && forStoreId !== '') {
                getSerialNoParams = { ...getSerialNoParams, forStoreId: forStoreId };
            }

            if (onlyLoginBranchStore && onlyLoginBranchStore === true) {
                getSerialNoParams = { ...getSerialNoParams, onlyLoginBranchStore: onlyLoginBranchStore };
            }

            if (onlyAvailableInStock && onlyAvailableInStock === true) {
                getSerialNoParams = { ...getSerialNoParams, onlyAvailableInStock: onlyAvailableInStock };
            }

            if (defectiveStatus && defectiveStatus === 'Y') {
                getSerialNoParams = { ...getSerialNoParams, defectiveStatus: defectiveStatus };
            }

            const response = await fetchApi("inventory/getItemSerialNos", getSerialNoParams, userToken);

            if (response.status === "Ok" && response.data.responseStatus === "Ok") {
                let newOptions = [];
                if (response.data.serailNosData && response.data.serailNosData.length > 0) {
                    newOptions = response.data.serailNosData.map(sn => ({ serialNo: sn }));
                }
                let preSelectedValues = [];

                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((s) => selectedValues.includes(s.serialNo));
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
            else {
                const newProps = { ...defaultProps, options: [], preSelectedValues: [], dataLoaded: true };
                setDefaultProps(newProps);
            }
        };

        getItemSerialNos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemId, forStoreId, onlyLoginBranchStore, onlyAvailableInStock, defectiveStatus]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((s) => selectedValues.includes(s.serialNo));
        }
        setDefaultProps({ ...defaultProps, editMode, preSelectedValues, dataLoaded: !editMode });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editMode, selectedValues]);

    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true };
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    return (defaultProps.dataLoaded || editMode ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default SerialNoFromInventoryAutocomplete;
